<h2 mat-dialog-title>Add Docs To: {{productionJob.title}}</h2>
<mat-dialog-content>
  <div>
    Total Docs Selected: {{selectedCount}}
  </div>
  <mat-checkbox *ngIf="selectedCount !== emailFamilyCount" labelPosition="before" [(ngModel)]="expandEmailFamily">Expand To Entire Email Family: {{emailFamilyCount}}</mat-checkbox>
  <br />
  <br />
  <div>
    Add {{expandEmailFamily ? emailFamilyCount : selectedCount}} docs?
  </div>
</mat-dialog-content>

<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" (click)="ok()">Ok</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
